import { useEffect, useState } from 'react'
import ReactDOM from "react-dom";
import Backdrop from '../../../common/modal/Backdrop';
import Modal from '../../../common/Modal';
import ModalInnerWrapper from '../../../common/ModalInnerWrapper';
import PannelBody from '../../../fragments/PannelBody';
import TextareaBox from '../../../common/interactive/TextareaBox';
import Button from '../../../common/Button';
import { resolveTask } from '../../../../lib/fetchApi';
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from '../../../../store/notifications';
import { caseActions } from '../../../../store/case';
import { tasksActions } from '../../../../store/tasks';

export default function ResolveTasks({showResolveTask, openResolveTask, itemData, inWorkQ, isTasksListing, workqId, caseData, createAnother}) {
    const [loadResolve, setLoadResolve] = useState(false)

    const dispatch = useDispatch()

    const [taskText, setTaskText] = useState('')

    const userToken = useSelector(state => state.user.token)
    const user = useSelector(state => state.user.user)

    const resolveTaskHandler = async (event) => {
        event.preventDefault()
        setLoadResolve(true)
        try {
            const fd = new FormData(event.target)
            const formData = Object.fromEntries(fd.entries())
            let reqBody = {
                note: formData.resolve_notes
            }


            let resolve = await resolveTask(userToken, itemData?.id, reqBody, inWorkQ ? workqId : null, inWorkQ ? dispatch : null, inWorkQ ? caseData?.case?.id : null)
            if (resolve && resolve.errorMessage) {
                dispatch(notificationActions.setError(resolve))     
            } else {            
                dispatch(notificationActions.setError({errorMessage: `Task Resolved`, type: 'success'}))           

                if (inWorkQ) {
                    // ################# when in work q there is nothing to do since dispatch in resolveTask takes care of everything!  #################        
                } else if (isTasksListing) {
                    // refresh the task api!!!!!!!! 
                    dispatch(tasksActions.setCurrentPage(1))
                    dispatch(tasksActions.setRefreshApi())
                } else {
                    let dispatchBody = {
                        folder: 'notes',
                        itemId: resolve?.id,
                        item: resolve
                    }   
                    dispatch(caseActions.pushWholeItemInArray(dispatchBody)) 
                }            

                if (openResolveTask) {
                    openResolveTask()
                }
            }
        } finally {
            setLoadResolve(false)
        }
    }

    function resolveTaskAddAnotherHandler() {
        if (createAnother) {
            if (taskText) {
                createAnother(itemData, taskText, isTasksListing)
            } else {
                dispatch(notificationActions.setError({errorMessage: 'Please complete the "notes" fields'}))
            }
        }
    }

    function setTaskTextHandler(value) {
        setTaskText(value.data.value)
    }

    useEffect(() => {
        if (!showResolveTask) return;
        const rafId = requestAnimationFrame(() => {
            const el = document.getElementById("resolve_notes");
            if (el && typeof el.focus === "function") {
                el.focus();
            }
        });
        return () => cancelAnimationFrame(rafId);
    }, [showResolveTask]);

    return <>
        {showResolveTask && <>
            {ReactDOM.createPortal(
                <Backdrop hide={openResolveTask} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={openResolveTask} modalTitle={'Resolve Task'}>
                        <PannelBody>
                            <form onSubmit={resolveTaskHandler}>
                                <div className="row">
                                    <TextareaBox label={'Notes'} name={'resolve_notes'} required={true} currentValue={taskText} action={setTaskTextHandler}/>
                                </div>         
                                <div className="row flex-container">
                                    <Button type={'submit'} isLoading={loadResolve}>Resolve task</Button>
                                    {user?.id == itemData?.user?.id && <Button btnStyle={'btn_text'} click={resolveTaskAddAnotherHandler} type={'button'}>not resolved add another one</Button>}
                                </div>
                            </form>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}